module.exports = __webpack_public_path__ + "img/bg.baebb61a.png";